import React from "react";

class ArticlesIcon extends React.Component {
  render() {
    return (
      <i className="anticon anticon-profile">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1.16em"
          height="1.18em"
          viewBox="0 0 20 17.969"
        >
          <path
            id="Forma_1"
            data-name="Forma 1"
            d="M64.316,503.193h8.132a0.56,0.56,0,1,0,0-1.119H64.316A0.56,0.56,0,1,0,64.316,503.193Zm0,1.924h8.132a0.56,0.56,0,1,0,0-1.12H64.316A0.56,0.56,0,1,0,64.316,505.117Zm4.3,6.575h-4.3a0.56,0.56,0,1,0,0,1.12h4.3A0.56,0.56,0,1,0,68.618,511.692Zm12.1-12.625L79,498.08a0.6,0.6,0,0,0-.441-0.064,0.584,0.584,0,0,0-.358.256l-2.984,4.776v-3.385a0.572,0.572,0,0,0-.583-0.56H61.583a0.572,0.572,0,0,0-.583.56V515.44a0.572,0.572,0,0,0,.583.56H74.637a0.572,0.572,0,0,0,.583-0.56v-6.484l5.7-9.121A0.547,0.547,0,0,0,80.717,499.067Zm-7.529,10.964-0.967.771,0.253-1.183,5.592-8.952,0.714,0.411Zm6.192-9.913-0.714-.411,0.237-.379,0.714,0.411ZM62.166,514.88V500.223H74.054v4.692l-1.03,1.647a0.518,0.518,0,0,0,.007-0.081,0.572,0.572,0,0,0-.583-0.56H64.316a0.56,0.56,0,1,0,0,1.12h8.132a0.594,0.594,0,0,0,.346-0.11l-0.571.914H64.316a0.56,0.56,0,1,0,0,1.119h7.208l-0.1.161a0.542,0.542,0,0,0-.071.175l-0.1.468H64.316a0.56,0.56,0,1,0,0,1.12h6.7l-0.268,1.251a0.551,0.551,0,0,0,.271.593,0.6,0.6,0,0,0,.672-0.049l2.322-1.851c0.016-.013.03-0.028,0.044-0.042v4.09H62.166Z"
            transform="translate(-61 -498.031)"
            fill="currentColor"
          />
        </svg>
      </i>
    );
  }
}

export default ArticlesIcon;
